<template>
  <v-parallax
    dark
    height="350"
    src="/inf.jpg"
  >
    <v-layout
      align-center
      justify-center
      wrap
    >
      <v-flex xs12 md4>
      </v-flex>
      <v-flex xs12 md4>
        <!-- <v-text-field
          label="Search"
          solo
          append-icon="send"
          @click:append=""
          hide-details
        >
        </v-text-field> -->
      </v-flex>
      <v-flex xs12 md4>
      </v-flex>
    </v-layout>
  </v-parallax>
</template>
<script>
import {firebase, auth, db} from '@/fb';

export default {
  data() {
    return {
      
    }
  },
  methods: {
    
  },
  created () {
  }
}
</script>

<style>

</style>